import ng1Response from '@fino/ng1-response';
import { ApiRequest } from '../../common/api/request';
const { FileResponse } = ng1Response;

export class InboxJobService extends ApiRequest {
  constructor($q, appConfig, $http) {
    'ngInject';
    super({ $q, appConfig, $http });
  }

  get apiPath() {
    return '/api/v0/aid/courier/jobs';
  }

  getNewDocuments(tenant) {
    return this.$http({
      method: 'GET',
      url: `${this.apiPath}/newDocuments`,
    });
  }

  getDoneDocuments(tenant) {
    return this.$http({
      method: 'GET',
      url: `${this.apiPath}/doneDocuments`,
    });
  }

  getRejectedDocumentsWithoutIBAN(tenant) {
    return this.$http({
      method: 'GET',
      url: `${this.apiPath}/rejectedDocumentsWithoutIBAN`,
    });
  }

  getNeedClarificationDocuments(tenant) {
    return this.$http({
      method: 'GET',
      url: `${this.apiPath}/needClarificationDocuments`,
    });
  }

  updateJob(id, data) {
    return this.$http({
      method: 'PUT',
      url: `${this.apiPath}/${id}`,
      data,
      error: {
        silent: true,
      },
    });
  }

  submitCommentForRejectedJobs(id, data) {
    return this.$http({
      method: 'POST',
      url: `${this.apiPath}/${id}/archive`,
      data,
    });
  }

  deleteJob(id) {
    return this.$http({
      method: 'DELETE',
      url: `${this.apiPath}/${id}`,
    });
  }

  download(id) {
    return this.$http({
      method: 'GET',
      url: this.getJobImageUrl(id),
      responseType: 'arraybuffer',
    }).then(FileResponse.transform);
  }

  getJobId(job) {
    return job && job._id;
  }

  getJobTaskView(job) {
    if (!job) return;
    return this.TaskTypeView[job.task];
  }

  isJobClosed(job) {
    return !!job.closed;
  }
}
